;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export interface JwtOrganisation {
  id: number;
  organisation_user_id?: number;
  currency_id: number;
  country_id: number;
  msa_details: {
    id: number;
    status: string;
  };
  /** Active view for users holding several roles in the organisation: EMPLOYER, EMPLOYEE, CONTRACTOR, GIG_WORKER. */
  role_context?: string | null;
  /** True when the user can switch between role contexts within the active organisation. */
  show_context_switcher?: boolean;
}

export interface JwtPayload {
  exp: number;
  iat: number;
  sub: string;
  user: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    new_app_access: boolean;
  };
  permissions: number[];
  roles: string[];
  teams?: {
    team_id: number;
    team_role: string[];
  }[];
  organisations?: JwtOrganisation[];
  active_organisation?: JwtOrganisation;
  accessible_app: string;
  has_completed_nps?: boolean;
}

export interface JwtUser {
  user: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
  };
  permissions: number[];
  roles: string[];
  teams?: {
    team_id: number;
    team_role: string[];
  }[];
  organisations: JwtOrganisation[];
  active_organisation?: JwtOrganisation;
  accessible_app: string;
  has_completed_nps?: boolean;
}

// Simple user interface without JWT complexity
export interface SimpleUser {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
}

// New SSO API response structure
export interface LoginResponse {
  message: string;
  data: {
    access_token: string;
    refresh_token: string;
  };
}

// Error response structure for SSO API
export interface LoginErrorResponse {
  message: string;
  errors: Record<string, string[]> | [];
}

// Refresh token response structure
export interface RefreshTokenResponse {
  message: string;
  data: {
    access_token: string;
    refresh_token: string;
  };
}

export interface ErrorWithStatusCode extends Error {
  statusCode?: number;
}
